<template>
    <div class="lg:my-0 relative inline-block w-48 my-3">
        <select :class="[onDarkBackground ? 'bg-budgets-darkgray-light border-budgets-darkgray-lighter text-gray-body' : 'bg-white border-gray-400 text-gray-body', 'block w-full px-3 py-2 pr-8 leading-tight border rounded appearance-none']" v-model="selectedLanguage" aria-label="Language">
            <option v-for="(language, key) in languages" :value="key">{{ language }}</option>
        </select>
        <div :class="[onDarkBackground ? 'text-gray-body' : 'text-gray-500', 'absolute inset-y-0 right-0 flex items-center px-2 pointer-events-none']">
            <svg class="w-4 h-4 fill-current" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/></svg>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        languages: {
            type: Object,
            required: true,
        },
        onDarkBackground: {
            type: Boolean,
            default: false,
        },
    },

    data() {
        return {
            selectedLanguage: window.Globals.locale,
            form: new Form({
                locale: '',
            }),
        };
    },

    watch: {
        selectedLanguage(value) {
            this.setLocaleCookie(value);
        },
    },

    methods: {
        setLocaleCookie(locale) {
            this.form.locale = locale;

            Globals.post('/set-locale-cookie', this.form)
                .then(() => window.location.reload())
                .catch(() => {
                    const errors = this.form.errors.flatten();
                    const message = errors.length > 0 ? errors[0] : this.$t('globals.unexpected_error');
                    window.toastr.clear();
                    window.toastr.error(message);
                    this.resetForm();
                });
        },

        resetForm() {
            this.form = new Form({
                locale: '',
            });
        },
    },
};
</script>
